import {
    SET_CITIES,
    SET_EDIT_CITY,
    SET_NEW_CITY,
    SET_DELETE_CITY,
    SET_DELETE_MULTI_CITY,
    SET_LIST_CITIES,
    SET_CITY,
    RESET_ITEMS_CITY,
    RESET_LIST_CITIES,
} from "redux/constants/Cities";

const initalAgreementState = {
    items: [],
    list: [],
    selected: {},
    loading: true,
};
const Cities = (state = initalAgreementState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_CITIES: {
            return { ...state, items: payload, loading: false };
        }
        case SET_LIST_CITIES: {
            return { ...state, list: payload };
        }
        case SET_CITY: {
            return { ...state, selected: payload };
        }
        case SET_NEW_CITY: {
            return { ...state, items: [payload, ...state.items] };
        }

        case SET_EDIT_CITY: {
            let list = [...state.items];

            try {
                let ind = list.findIndex((item) => item._id === payload._id);

                if (ind > -1) {
                    list[ind] = payload;
                }
            } catch (error) {}

            return { ...state, items: list };
        }

        case SET_DELETE_CITY: {
            let list = state.items.filter((item) => item._id !== payload);

            return { ...state, items: list };
        }

        case SET_DELETE_MULTI_CITY: {
            let arr = payload.split(",");
            let list = state.items.filter((item) => !arr.includes(item._id));

            return { ...state, items: list };
        }
        case RESET_LIST_CITIES: {
            return { ...state, list: [], loading: true };
        }

        case RESET_ITEMS_CITY: {
            return { ...state, items: [], loading: true };
        }

        default:
            return state;
    }
};

export default Cities;
